const getModule = () => import('./dam.module')

const lazyLoadModule = [
  '$q',
  '$ocLazyLoad',
  ($q, $ocLazyLoad) => {
    const deferred = $q.defer()
    getModule().then(({ damModule }) => {
      $ocLazyLoad.load({
        name: damModule.name
      })
      deferred.resolve(damModule)
    })
    return deferred.promise
  }
]

const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  ($q, $state, $rootScope) => {
    const deferred = $q.defer()

    Promise.all([
      $rootScope.getUser(),
      $rootScope.getCompanyConfigurations()
    ])
      .then(([user, configs]) => {
        $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
          const isUserSysAdminAdminDesigner = $rootScope.isUserSysAdminAdminDesigner(user)
          const shouldShowModule = (isUserSysAdminAdminDesigner || configs.ENABLE_USER_DAM_MODULE) && features['FILES.ACCESS']

          if (shouldShowModule) {
            deferred.resolve()
          } else {
            deferred.reject()
          }
        })
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('dam', {
      url: '/files/:uuid?asset&search',
      reloadOnSearch: false,
      views: {
        '': {
          templateUrl: '/dam/dam.html?$$REVISION$$',
          controller: 'DamController'
        },
        'gallery@dam': {
          templateUrl: '/dam/pages/gallery/gallery.html?$$REVISION$$',
          controller: 'GalleryController'
        }
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })

  $urlRouterProvider.when('/files?asset&search', '/files/?asset&search')
  $urlRouterProvider.when('/files/?asset&search', '/files?asset&search')
}

export const damRoutes = routes
